import { forwardRef, useId } from 'react'
import { cn } from '../../lib/cn'

interface TextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  label?: string
  error?: string
}

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ label, error, className, id, ...props }, ref) => {
    const generatedId = useId()
    const textareaId = id || generatedId

    return (
      <div className="space-y-1.5">
        {label && (
          <label htmlFor={textareaId} className="block text-sm font-medium text-text">
            {label}
          </label>
        )}
        <textarea
          ref={ref}
          id={textareaId}
          className={cn(
            'block w-full rounded-control bg-surface-sunken px-3 py-2.5 text-base text-text leading-relaxed',
            'ring-1 ring-border transition duration-200 ease-out placeholder:text-text-faint',
            'focus:outline-none focus:ring-2 focus:ring-ember-400/50',
            'disabled:opacity-50 disabled:cursor-not-allowed',
            error && 'ring-danger/60 focus:ring-danger/60',
            className,
          )}
          aria-invalid={error ? true : undefined}
          aria-describedby={error ? `${textareaId}-error` : undefined}
          {...props}
        />
        {error && (
          <p id={`${textareaId}-error`} className="text-xs text-danger-fg">
            {error}
          </p>
        )}
      </div>
    )
  },
)

Textarea.displayName = 'Textarea'
